var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BannerComponent',{staticClass:"banner"}),_c('CarrosselComponent2',{staticClass:"carousel"}),_c('TextosDescritivos'),_c('v-row',{staticClass:"marcas"},_vm._l((_vm.paths),function(logo,index){return _c('img',{key:index,attrs:{"src":`../img/ws/` + logo,"width":"50%","alt":"logos"}})}),0),_c('FooterWs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }